export default __webpack_public_path__ + "static/media/Eagle.550869e1.png";